/**
 * @fileoverview GET handler for the "/app_settings/:app_group_id/message_prioritization/rules_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationRulesData } from "./constants";
import type { GetMessagePrioritizationRuleDataParams, MessagePrioritizationRulesDataResult } from "./types";
import { isMessagePrioritizationRulesDataResult } from "./validators";

export const getMessagePrioritizationRulesData = reactQueryFetcherAdapter(
  appSettingsAppGroupIdMessagePrioritizationRulesData,
  (
    signal: AbortSignal,
    { appGroupId }: GetMessagePrioritizationRuleDataParams
  ): Promise<MessagePrioritizationRulesDataResult> => {
    return fetch(`/app_settings/${appGroupId}/message_prioritization/rules_data`, "GET", {}, { signal });
  },
  isMessagePrioritizationRulesDataResult
);
